import { KyInstance } from 'ky';

import { handleRequest } from '@/utils/httpUtils';

import type { CheckUserExists, UserExistsResponse } from './types';

export interface IReqFulfillUsers {
  checkUserExists: CheckUserExists;
}

export function reqFulfillUsers(http: KyInstance): IReqFulfillUsers {
  const route = 'api/v1/users';
  return {
    checkUserExists: (clientId: string) =>
      handleRequest<UserExistsResponse>(http, 'get', `${route}/exists`, {
        searchParams: { clientId },
      }),
  };
}
